module.exports = __webpack_public_path__ + "img/58_9.377f3871.png";